import { BaseApi } from './base-api.service';
import URL from '../../constants/api-constants';
import { generatePath } from 'react-router-dom';
import { Cycle } from '../models/cycles';
import CycleStatus from '../../enums/cycle-status.enum';
import ContractStatus from '../../enums/status-contracts-location.enum';

export enum CycleScreenQuerySetting {
  ALL = 'all',
  NO_SCREEN = 'no_screen',
  WITH_SCREENS = 'with_screens',
}

export class CycleDataService {
  private static readonly apiService = new BaseApi();

  static async getActiveWithoutScreen(contractId: string): Promise<Cycle[]> {
    const path = generatePath(URL.CYCLES_CONTRACT_IOT_LATEST, { contractId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        status: CycleStatus.Active,
        screens: CycleScreenQuerySetting.NO_SCREEN,
      },
    });

    return data.data;
  }

  static async getActiveWithoutScreenByLocation(locationId: string): Promise<Cycle[]> {
    const path = generatePath(URL.CYCLES_LOCATION_IOT_LATEST, { locationId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        status: CycleStatus.Active,
        screens: CycleScreenQuerySetting.NO_SCREEN,
      },
    });

    return data.data;
  }

  static async getCompleted(contractId: string): Promise<Cycle[]> {
    const path = generatePath(URL.CYCLES_CONTRACT, { contractId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        status: CycleStatus.Completed,
      },
    });

    return data.data;
  }

  static async getInactive(contractId: string): Promise<Cycle[]> {
    const path = generatePath(URL.CYCLES_CONTRACT, { contractId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        status: CycleStatus.InActive,
      },
    });

    return data.data;
  }

  static async getInactiveByLocation(payload: {
    locationId: string;
    query: { contractStatus: ContractStatus };
  }): Promise<Cycle[]> {
    const { locationId, query } = payload;
    const path = generatePath(URL.CYCLES_LOCATION, { locationId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        ...query,
        cycleStatus: CycleStatus.InActive,
      },
    });

    return data.data;
  }

  static async getDeletedByLocation(locationId: string): Promise<Cycle[]> {
    const path = generatePath(URL.CYCLES_LOCATION_DELETED, { locationId });

    const data = await this.apiService.api.get<Cycle[]>(path);

    return data.data;
  }

  static async getActiveByLocation(payload: {
    locationId: string;
    query: { contractStatus: ContractStatus };
  }): Promise<Cycle[]> {
    const { locationId, query } = payload;
    const path = generatePath(URL.CYCLES_LOCATION, { locationId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        ...query,
        cycleStatus: CycleStatus.Active,
      },
    });

    return data.data;
  }

  static async getCompletedByLocation(payload: {
    locationId: string;
    query: { contractStatus: ContractStatus };
  }): Promise<Cycle[]> {
    const { locationId, query } = payload;
    const path = generatePath(URL.CYCLES_LOCATION, { locationId });

    const data = await this.apiService.api.get<Cycle[]>(path, {
      params: {
        ...query,
        cycleStatus: CycleStatus.Completed,
      },
    });

    return data.data;
  }
}
